export const SAVE_VC_PICTURE = id => `SAVE_VC_PICTURE_${id}`;
export const REFRESH_PICTURES = id => `REFRESH_PICTURES_${id}`;
export const UPDATE_VC_PICTURE = id => `UPDATE_VC_PICTURE_${id}`;

export const saveVCPicture = (id, data) => ({ type: SAVE_VC_PICTURE(id), data });
export const refreshPictures = vcId => ({ type: REFRESH_PICTURES(vcId) });
export const updateVcPicture = (id, data) => ({ type: UPDATE_VC_PICTURE(id), data });
